import { createContext, useContext, type JSX } from "solid-js";
import { apiPrefix, makeApi, type Api } from "./client.ts";

const ApiContext = createContext<Api>();

export type ApiProviderProps = {
  value: Api;
  children: JSX.Element;
};

export const ApiProvider = (props: ApiProviderProps) => (
  <ApiContext.Provider value={props.value}>{props.children}</ApiContext.Provider>
);

/** Components never import a live client; they ask context for one. */
export const useApi = (): Api => useContext(ApiContext) ?? makeApi(apiPrefix);
